// extracted by mini-css-extract-plugin
export default {"checkout-page":"checkout_checkout-page__VjpxQ","form-card":"checkout_form-card__Ser-5","form-card-content":"checkout_form-card-content__Y7MBE"};